// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".public-logo-img[data-v-708c0c3b]{position:fixed;width:284px;height:120px;top:80px;left:80px;z-index:999}", ""]);
// Exports
module.exports = exports;
